import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import Icon from '../../../Assets/Icon/CustomIcon';
import WorkList from '../ui/WorkList';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const tabLabels = ['전체', '중지', '미해결', '승인'];

export default function M_WOS_BASIC(props) {
  const [value, setValue] = React.useState(0);
  const [searchInput, setSearchInput] = useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleSearch = () => {
    props.searchRef.current.searchText = searchInput;
    props.setSearchClick(true);
  };

  const filteredData = React.useMemo(() => {
    if (!props.rowData1) return [];

    const currentTab = tabLabels[value];

    if (currentTab === '전체') {
      return props.rowData1;
    }

    return props.rowData1.filter((item) => item.gubun === currentTab);
  }, [value, props.rowData1]);

  return (
    <Box
      sx={{
        height: 'calc(100vh - 56px)',
        display: 'flex',
        flexDirection: 'column',
        px: 2,
      }}
    >
      {/* Tabs */}
      <Box sx={{ flexShrink: 0 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tabs"
          variant="scrollable"
          scrollButtons={false}
          TabIndicatorProps={{
            style: { backgroundColor: '#0D843F', height: '2px' },
          }}
          sx={{ minHeight: '28px' }}
        >
          {tabLabels.map((label, index) => (
            <Tab
              key={index}
              label={label}
              {...a11yProps(index)}
              sx={{
                minHeight: '28px',
                minWidth: 'auto',
                fontSize: '14px',
                fontWeight: value === index ? 700 : 400,
                color: value === index ? '#0D843F' : '#000',
                px: 1,
                py: 0,
              }}
            />
          ))}
        </Tabs>

        {/* 검색창 */}
        <Box
          sx={{
            width: '100%',
            border: '1px solid #ccc',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            pr: '8px',
            my: 1,
          }}
        >
          <input
            type="text"
            placeholder="검색어를 입력해주세요."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            style={{
              height: '36px',
              fontSize: '16px',
              padding: '0 10px',
              border: 'none',
              outline: 'none',
              width: '100%',
              backgroundColor: 'transparent',
            }}
          />
          {props.searchClick ? (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={() => {
                setSearchInput('');
                props.searchRef.current.searchText = '';
                props.setSearchClick(false);
              }}
            >
              <Icon.Close />
            </button>
          ) : (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={handleSearch}
            >
              <Icon.Search />
            </button>
          )}
        </Box>
        <p style={{ fontWeight: 'bold', padding: '0.5rem 0' }}>
          총{filteredData.length}건
        </p>
      </Box>

      {/* 리스트 */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        {filteredData.length === 0 ? (
          <Box
            sx={{
              height: 'calc(100% - 120px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#888',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            조회된 데이터가 없습니다.
          </Box>
        ) : (
          <WorkList workinfoData={filteredData} userInfo={props.userInfo} />
        )}
      </Box>
    </Box>
  );
}
